import { render, staticRenderFns } from "./RegisterBatchModalOld.vue?vue&type=template&id=0de3ca55&scoped=true&"
import script from "./RegisterBatchModalOld.vue?vue&type=script&lang=js&"
export * from "./RegisterBatchModalOld.vue?vue&type=script&lang=js&"
import style0 from "./RegisterBatchModalOld.vue?vue&type=style&index=0&id=0de3ca55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de3ca55",
  null
  
)

export default component.exports